/** 
 * 用户 Store
 * @author LiQingSong
 */
import { login, logout, getUserInfo } from '@/api/login'
import { getToken, setToken, removeToken, removeTenantId } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    userInfo: {},
    avatar: '',
    permissions: [],
    userRoles: [],
    pageSize: 10,
    dialogModal: true,
    waterMark: false,
    waterMarkMsg: '',
    chLoginName: false,
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
    SET_AVATAR: (state, avatar) => {
      state.userInfo.avatar = avatar
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_USER_ROLES: (state, userRoles) => {
      state.userRoles = userRoles
    },
    SET_PAGE_SIZE: (state, pageSize) => {
      state.pageSize = pageSize;
    },
    SET_DIALOG_MODAL: (state, dialogModal) => {
      state.dialogModal = dialogModal;
    },
    WATER_MARK: (state, waterMark) => {
      state.waterMark = waterMark;
    },
    WATER_MARK_MSG: (state, waterMarkMsg) => {
      state.waterMarkMsg = waterMarkMsg;
    },
    SET_LOGO: (state, logo) => {
      state.userInfo.logo = logo;
    },
    CH_LOGIN_NAME: (state, chLoginName) => {
      state.chLoginName = chLoginName;
    }
  },

  actions: {
    // 設置頭像
    setAvatar({ commit }, data) {
      commit('SET_AVATAR', data);
    },
    // 設置LOGO
    setLogo({ commit }, data) {
      commit('SET_LOGO', data);
    },
    // 切换角色
    switchRole({ commit }, token) {
      commit('SET_TOKEN', token);
      setToken(token);
    },
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(res => {
          commit('SET_TOKEN', res.token);
          setToken(res.token);
          // 登錄成功后移除TenantId
          removeTenantId();
          resolve();
        }).catch(error => {
          reject(error);
        });
      });
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo(state.token).then(res => {
          if (!res.data) {
            reject(res.msg || 'Error');
          }
          // 用戶信息
          var userInfo = {
            userId: res.data.userId,
            name: res.data.name,
            loginName: res.data.loginName,
            lastRole: res.data.lastRole,
            initPwd: res.data.initPwd,
            cid: res.data.cid,
            avatar: res.data.avatar,
            logo: res.logo,
            displayName: res.displayName,
            clientName: res.clientName,
            url: res.url,
            dbVersion: res.lyodsVersion
          }
          if (res.pageSize) {
            commit('SET_PAGE_SIZE', parseInt(res.pageSize));
          }
          if (res.dialogModal === false || res.dialogModal === true) {
            commit('SET_DIALOG_MODAL', res.dialogModal);
          }
          if (res.waterMark === false || res.waterMark === true) {
            commit('WATER_MARK', res.waterMark);
            if (res.waterMark) {
              commit('WATER_MARK_MSG', res.waterMarkMsg);
            }
          }
          if(res.chLoginName === false || res.chLoginName === true){
            commit('CH_LOGIN_NAME',res.chLoginName);
          }
          // roles must be a non-empty array
          /* if (!roles || roles.length <= 0) {
              reject('用户没有角色权限!');
          } */
          commit('SET_USER_INFO', userInfo);
          commit('SET_USER_ROLES', res.userRoles);
          resolve(res.data);
        }).catch(error => {
          reject(error);
        });
      })
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout({ username: state.userInfo.loginName }).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_USER_INFO', {});
          commit('SET_PERMISSIONS', [])
          commit('SET_USER_ROLES', [])
          removeToken()
          // TenantId
          removeTenantId();
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_USER_INFO', {});
        commit('SET_PERMISSIONS', [])
        commit('SET_USER_ROLES', [])
        removeToken()
        // TenantId
        removeTenantId();
        resolve()
      })
    }
  }
}

export default user


// WEBPACK FOOTER //
// ./src/store/modules/user.js